import React, { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";

import "./dashboardComponents/dash.css";
import Dsidebar from "./dashboardComponents/Dsidebar";
import Topnav from "./dashboardComponents/Topnav";
import MobileNavbar from "./dashboardComponents/FixedNavbar";
import AiModule from "./dashboardComponents/AiModule";

export default function DashboardLayout() {
  const [showsidebar, setShowside] = useState(false);
  const location = useLocation();
  const isChatPage =
    location.pathname.includes("/chat") ||
    location.pathname.endsWith("/chat") ||
    location.pathname.includes("/ai") ||
    location.pathname.endsWith("/ai");


  const toggleSidebar = () => {
    setShowside(!showsidebar);
  };
  const RetailerPath = location.pathname.includes("/retailer-dashboard");
  const ExpertsPath = location.pathname.includes("/expert-dashboard");
  return (
    <div className="dashboard-apwen">
      <Dsidebar showsidebar={showsidebar} toggleSidebar={toggleSidebar} />
      <div className="main-dash-sec">
        <div
          className={`dark-body ${showsidebar ? "active" : ""}`}
          onClick={toggleSidebar}
        ></div>
        {!isChatPage && <Topnav toggleSidebar={toggleSidebar} />}

        <div className={`main-dash-content${isChatPage ? "no-padding" : ""}`}>
          <Outlet />
        </div>
      </div>

      {!isChatPage && (
        <>
          <MobileNavbar />
          <AiModule />
        </>
      )}
      {/*    {!isChatPage && !RetailerPath && !ExpertsPath && <AiModule />} */}
    </div>
  );
}
